/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BalanceBracketMode {
    ALL = 'All',
    ALL_EARNED_POINTS = 'AllEarnedPoints',
    ALL_DOWNSIZED_BILLS = 'AllDownsizedBills',
}
